// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"0175b578","646":"317bbe78"}[chunkId] + ".chunk.js";
};